import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { formatDate } from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import type { RootState } from 'af-reducers';

type Props = ConnectedProps<typeof connector>;

const DisplayViewNavigation: React.FC<Props> = (props: Props) => {
	const { displayViewDate } = props;

	return (
		<div className="display-view-navigation">
			<div className="display-view-navigation-title">
				{formatDate(displayViewDate, TimeFormat.SB_DATE_LONG)}
			</div>
		</div>
	);
};

function mapStateToProps(state: RootState) {
	return {
		displayViewDate: state.scheduleBoard.displayViewDate,
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType>(
	React.memo,
	connector
);

export default enhance(DisplayViewNavigation);
